import type { ColumnDef } from '@tanstack/vue-table'
import { Users } from '../../tables/Users'

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.

export const usersColumns: ColumnDef<Users.ListItem>[] = [
  {
    accessorKey: 'email',
  },
  {
    accessorKey: 'roles',
  },
  {
    accessorKey: 'insertTime',
  },
  {
    // These actions will be gotten from the `actions` field in the schema.
    id: 'actions',
  },
]
